"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  toastParamErrorTitle: {
    "id": "Param Error {param}",
    "defaultMessage": "Param Error {param}"
  }
});
exports.messages = messages;
//# sourceMappingURL=toastr-i18n.js.map